import { useContext } from 'react';

import { PageContext } from './page-header-context';

export const usePageContext = () => useContext(PageContext);
